import topups from "./topups.component";
import topupsUrls from "./topups.urls";
import TopupsTransforms from "./topups.transforms";

const topupsModule = angular
  .module("app.components.topups", [])
  .component("topupsPage", topups)
  .service("TopupsTransforms", TopupsTransforms)
  .config(topupsUrls);

export default topupsModule;



// WEBPACK FOOTER //
// ./src/pages/topups/topups.module.js